import { render, staticRenderFns } from "./onSiteManagement.vue?vue&type=template&id=21f73174&scoped=true&"
import script from "./onSiteManagement.vue?vue&type=script&lang=js&"
export * from "./onSiteManagement.vue?vue&type=script&lang=js&"
import style0 from "./onSiteManagement.vue?vue&type=style&index=0&id=21f73174&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f73174",
  null
  
)

export default component.exports